// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card.theme--dark[data-v-5c1bd680],.v-card.theme--light[data-v-5c1bd680]{background-color:#fff!important}[data-v-5c1bd680] h1{line-height:normal;margin-bottom:30px}[data-v-5c1bd680] h2{line-height:normal;margin-top:40px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
